import useIntl from '@/utils/intl'
import React, { FunctionComponent, useReducer } from 'react'
import { Obj } from '..'
import { Categories, TouristPackage, PackageDetailInfo, SubCategories, serviceDetail } from '@/services/mobi-api/tourist/types'
import Loader from '@/components/ui/loader'
import { Checkbox } from '@mui/material'
import classNames from 'classnames'
import { CheckCircle, RadioButtonUncheckedOutlined } from '@mui/icons-material'
import { useToast } from '@/context/ToastContext'

interface Props {
  next: (obj: Obj) => void
  back: () => void
  dataPackage: TouristPackage | undefined
}

interface State {
  package?: TouristPackage
  loading?: boolean
  choosenCategory?: Categories
  choosenSubCat?: SubCategories
  choosenCallMM?: serviceDetail
  choosenDataMM?: serviceDetail
  choosenPackage?: PackageDetailInfo
  choosenPackageDummy?: String
  lang?: string
}

const ChoosePackage: FunctionComponent<Props> = ({ next, back, dataPackage }) => {
  const { translate } = useIntl()
  const { showError } = useToast()
  const [state, setState] = useReducer(
    (state: State, newState: State) => ({ ...state, ...newState }),
    {
    }
  )

  const handleSavePackage = (choosenPackage: PackageDetailInfo): void => {
    const packageData: PackageDetailInfo = choosenPackage

    try {
      next({ choosenPackage: packageData })
    } catch (e) {
      showError(translate('tourist.request.failed'))
    } finally {
      setState({ loading: false })
    }
  }

  if (state.package === undefined && state.loading === true) {
    return (
      <div className='flex w-full justify-center items-center'>
        <Loader />
      </div>
    )
  }

  return (
    <div className='bg-surfaceMid rounded-xl p-6 md:p-8 flex flex-col items-start justify-center gap-4'>
      <div className='grid grid-cols-2 gap-1 w-full overflow-auto'>
        {dataPackage?.categories?.[0]?.subCategories?.[0] !== undefined
          ? dataPackage?.categories[0].subCategories[0].packages.map((item, i) => (
            <div
              key={i} onClick={() => { handleSavePackage(item) }} className={classNames('border rounded-xl p-3 cursor-pointer flex justify-between items-start bg-surfaceInverse'
              )}
            >
              <div className='flex flex-col w-5/6'>
                {item.duration !== undefined
                  ? <span className='text-xs text-textMid truncate'>{item.duration} {item.duration > 1 ? translate('tourist.days') : translate('tourist.day')}</span>
                  : <></>}
                <span className='text-lg text-textHigh font-bold'>{item.name}</span>

                <span className='mt-3 text-sm text-textHigh'>{item.basePrice}₮</span>
              </div>
              <Checkbox
                color='error' icon={<RadioButtonUncheckedOutlined className='text-textHigh' />}
                checkedIcon={<CheckCircle className='text-primaryMain' />} className='p-0' checked={false}
              />
            </div>
          ))
          : <> </>}

      </div>

    </div>
  )
}
export default ChoosePackage
